<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" @click.self="$emit('close')">
    <div class="bg-white rounded-lg w-full sm:max-w-lg max-w-md shadow-lg flex flex-col pb-6 relative mx-4">
      <!-- Modal Header -->
      <button type="button" class="absolute top-3 right-3 text-2xl text-gray-400 hover:text-gray-600" @click="$emit('close')">
        <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      <div class="flex flex-col px-8 pt-8 mb-4">
        <h3 class="text-lg font-medium text-center mb-4 text-black">
          ¿Cómo encontrar mi propiedad en Clasificados?
        </h3>
        <p class="text-base font-normal text-custom_gray text-start mb-2">
          Sigue los siguientes pasos.
        </p>

        <div class="grid grid-cols-[auto,1fr] gap-x-3 gap-y-2">
          <span class="text-base font-normal text-custom_gray">1.</span>
          <p class="text-base font-normal text-custom_gray">
            Haz clic en el botón de abajo.
          </p>

          <span class="text-base font-normal text-custom_gray">2.</span>
          <p class="text-base font-normal text-custom_gray">
            Ingresa el tipo de propiedad y la ubicación en el buscador.
          </p>

          <span class="text-base font-normal text-custom_gray">3.</span>
          <p class="text-base font-normal text-custom_gray">
            Desplázate hasta tu publicación.
          </p>
        </div>
      </div>
      <div class="flex justify-center gap-4 px-8">
				<a 
					href="https://clasco.mx/bienesraices" 
					target="_blank" 
					rel="noopener noreferrer"
					@click="$emit('close')"
					class="text-base px-3 py-2 rounded-md bg-tuin-100 text-white font-medium hover:bg-tuin_hover transition"
				>
					Ver en Clasificados
				</a>
      </div>
    </div>
  </div>
</template>

<script>

</script>

<style scoped>
</style>